import { Component } from "react";
import "./PageFormWithHeader.css";
import PageForm from "./PageForm";

export default class PageFormWithHeader extends Component {
  render() {
    const title = this.props.titleComponent ? (
      this.props.titleComponent
    ) : (
      <div className="title-container">
        {this.props.headerImg && (
          <img src={this.props.headerImg} alt="form header icon" />
        )}
        <span>{this.props.title}</span>
      </div>
    );

    return (
      <PageForm
        mode={this.props.mode}
        onFormSubmitted={this.props.onFormSubmitted}
        isValidForm={this.props.isValidForm}
        formClassName={this.props.formClassName}
        onClose={this.props.onClose}
        titleComponent={title}
        showSpinner={this.props.showSpinner}
        formActions={this.props.formActions}
        verticalActions={this.props.verticalActions}
        errors={this.props.errors}
        topBorder={this.props.topBorder}
        wrapperClassName={this.props.wrapperClassName}
        className={"with-header " + this.props.className}
        withLogo={this.props.withLogo}
        dataCy={this.props.className + "-container"}
      >
        {this.props.children}
      </PageForm>
    );
  }
}
